import { FC, useContext } from 'react';
import { ProfileSetupContext } from './ProfileSetupContext';
import { StepperIndicator } from '@vs-online-only-app/ui';

const ProfileSetupFooter: FC = () => {
  const { nrOfSteps, currentStepIndex } = useContext(ProfileSetupContext);

  return (
    <StepperIndicator
      nrOfSteps={nrOfSteps}
      currentStepIndex={currentStepIndex}
    />
  );
};

export default ProfileSetupFooter;
